module.exports = "/_next/static/files/15b67de883a62be824d263fbd08325c6.svg";